import { render, staticRenderFns } from "./ModalDeshabilitar.vue?vue&type=template&id=395af17a&scoped=true"
import script from "./ModalDeshabilitar.vue?vue&type=script&lang=js"
export * from "./ModalDeshabilitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395af17a",
  null
  
)

export default component.exports